"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
/* DESTRUCTURING */
const { apply } = Reflect;
/* APPLICATORS */
const setDate = (method, thisArg, thisArgTarget, args) => {
    const prev = thisArgTarget.getTime(), result = apply(method, thisArg, args), next = thisArgTarget.getTime(), changed = (prev !== next);
    return [result, changed];
};
/* DATE */
const Date = { setDate };
/* EXPORT */
exports.default = Date;
